import { render } from "./AccountUser.vue?vue&type=template&id=ae95f0ea"
import script from "./AccountUser.vue?vue&type=script&lang=js"
export * from "./AccountUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__